import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import Status from "@/vuex/Status";
import MetaData from "@/assets/MetaData";
import CatchFetch from "@/assets/Cache/Fetch";
import DAOWishlist from "../../../../public/js/DAO/Wishlist";
import Notification from "@/assets/Helper/Notification";
import i18n from "@/i18n";
import Logger from "@/assets/Helper/Logger";

let DAOItemDescription = function () {

    this.getDescription = function (itemnumbers) {
        if (Array.isArray(itemnumbers)) {
            Status.dispatch('setLoading', true).catch((error) => {
                Logger.error(error);
            });

            let url = Config.getters.getApiHostWithLocalStr + '/v2/items/description/' + itemnumbers.join('/') + '/?shop=' + Config.getters.isShopLoginActive;

            CatchFetch.cacheFirst(url)
                .then(json => {
                    if (json.status === false) {
                        Notification.create(i18n.t('Common.available.title'), i18n.t('Common.available.text'));

                        DAOWishlist.drop('configure', SetData.getters.getWishlistItemId).catch((error) => {
                            Logger.error(error);
                        });

                        SetData.dispatch('clearItems', true).catch((error) => {
                            Logger.error(error);
                        });
                    } else {
                        SetData.dispatch('setSummary', json.result.summary).catch((error) => {
                            Logger.error(error);
                        });

                        for (let i in json.result.items) {
                            if (json.result.items[i] && json.result.items[i]['available'] === false) {
                                Notification.create(
                                  i18n.t("Common.available.title"),
                                  "",
                                    false
                                );
                            }
                            if (Object.prototype.hasOwnProperty.call(json.result.items, i)) {
                                SetData.dispatch('setItemDescription', json.result.items[i]).catch((error) => {
                                    Logger.error(error);
                                });
                            }
                        }

                        MetaData.set();
                    }
                    Status.dispatch('setLoading', false).catch((error) => {
                        Logger.error(error);
                    });
                })
                .catch((error) => {
                    Status.dispatch('setLoading', false).catch((error) => {
                        Logger.error(error);
                    });
                    Logger.error(error);
                });
        }
    }
}

export default new DAOItemDescription();
